<template>

	<v-row class="mt-16 mb-5">

		<v-col offset-lg="3" lg="6" offset-md="2" md="8" offset-sm="1" sm="10">

    	<v-card class="pa-4" elevation="20" style="color: #c0c0c0;background: #202020;">

    		<div class="text-center">
    		  <router-link to="/"><img src="@/assets/img/logo.png" alt="Logo" id="auth-logo" width="100"></router-link>
    		</div>
    			
  			<h3 class="text-center">Activar cuenta</h3>

  			<p class="mt-4 text-center" v-if="wait">
  				Espera un momento por favor...
  			</p>

  			<p class="mt-4 text-center" v-if="error" style="color: red">
  				Ha ocurrido un error, por favor intenta de nuevo.
  			</p>

    	</v-card>

		</v-col>

	</v-row>

</template>


<script>
	
	import UserService from '@/shared/services/UserService'

	export default 
	{

		data() { 
			return {
				email: this.$route.params.email,
				token: this.$route.params.token,

				wait: true,
				error: false
			}
		},

	  mounted(){
	  	this.activateAccount()
		},

		methods: {
			
			async activateAccount()
			{
				let data = {
					email: this.email,
					token: this.token
				}
				const resp = await UserService.activateAccount(data)

				console.log(resp.data)


				if(resp.data.mesg == 'OK')
				{
					SwalAlert('', 'Tu cuenta ha sido activada exitosamente', 'success')
					localStorage.setItem('token', resp.data.token)
					this.$router.push('/usuario')
				}
				else if(resp.data.mesg == 'ERROR')
				{
					this.wait = false
					this.error = true
				}
			}

		}
	}

</script>